import { render, staticRenderFns } from "./verification-waiting.vue?vue&type=template&id=d7f4f040&scoped=true"
import script from "./verification-waiting.vue?vue&type=script&lang=js"
export * from "./verification-waiting.vue?vue&type=script&lang=js"
import style0 from "./verification-waiting.vue?vue&type=style&index=0&id=d7f4f040&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f4f040",
  null
  
)

export default component.exports